import React from 'react'
import { getFetchConfig } from '../Base/modelManager'
import { message } from  "antd"



export const excelExport = (url, outputName, filterStr, sorterStr, getToken) => {
    return {
        id: 'export',
        icon:<img src="/assets/images/icons/picto_export_xls.svg" alt="Bootstrap" width="20" height="20" className='gridHeaderImage'/>,
        tooltip: 'Export Excel',
        onExecute: (e) => {
            const hide = message.info('Traitement en Cours..', 0);
            const sender = e.target
            sender.disabled = true;

          
            const request={
                  method: 'GET',
                   token: getToken() 
            }
           
           
            return fetch(url + '?' + filterStr() + sorterStr(), getFetchConfig(request))
                .then(response => {
                    response.blob()
                        .then(blob => {
                            setTimeout(hide, 0)
                            message.success('Enregistrement effectué', 3)
                            sender.disabled = false;
                            let urlup = window.URL.createObjectURL(blob);
                           // window.open(url)
                            let a = document.createElement('a');
                            a.href = urlup;
                            a.download = outputName;
                            a.click();
                        }).catch(error => {
                            setTimeout(hide, 0)
                            sender.disabled = false;
                            message.error(error)
                        })
                })
                .catch(error => {
                    setTimeout(hide, 0)
                    message.error(error)
                })

        }
    }
}